var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "account-manage-users-list" },
    _vm._l(_vm.users, function (user) {
      return _c("user-row", {
        key: user.id,
        attrs: {
          user: user,
          "search-term": _vm.searchTerm,
          "is-current-user": user.id === _vm.userAccount.id,
          "current-user-is-admin": _vm.currentUserIsAdmin,
          "current-user-account": _vm.userAccount,
        },
        on: {
          editUser: function ($event) {
            return _vm.editUser(user)
          },
          confirmUser: function ($event) {
            return _vm.confirmUser(user)
          },
          deactivateUser: function ($event) {
            return _vm.deactivateUser(user)
          },
          resendInvitation: function ($event) {
            return _vm.resendInvitation(user)
          },
          removeInvitation: function ($event) {
            return _vm.removeInvitation(user)
          },
          changeAccountType: function ($event) {
            return _vm.changeAccountType(user)
          },
        },
      })
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }